<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div class="margin_top_20">

      <weex-text class="input_label" >
        {{cancelledChequeInstruction}}
      </weex-text>

      <file-attach-button
        class="horizontal_center margin_top_40"
        size="medium"
        file-attach-button-id="upload_cancelled_cheque"
        :show-attach-description="showFieldError('cancelled_cheque_uploaded')"
        :attach-description="getErrorMsg('cancelled_cheque_uploaded')"
        text="Upload Cancelled Cheque"
        :attach-image-des-src="documentAttachImage"
        :enabled-text-style="attachFileButtonTextStyle"
        :enabled-btn-style="attachFileButtonStyle"
        @filesAttached="onCancelledChequeAttached"
      ></file-attach-button>

      <wxc-button
        text="Next"
        class="margin-top-40 margin-bottom-20 horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import FileAttachButton from "../layout/FileAttachButton";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import AlertService from "../core/alert/AlertService";
import { EntityType } from "../../utils/EntityType";
import { DocumentDescription } from "../../utils/DocumentDetails";
import DynamicFieldUtils, { FieldTypes } from "../../utils/DynamicFieldUtils";

const DOCUMENT_UPLOADED = "Document uploaded successfully";

const ALL_FIELDS_DATA = {
  cancelled_cheque_uploaded: {
    validation: "",
    fieldType: FieldTypes.BUTTON,
    errorMsg: "<div style='color: red; font-size: 14px; text-align: center'>Please upload Cancelled Cheque</div>",
    optional: false
  }
};

export default {
  name: "CancelledChequeActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    FileAttachButton,
    WxcButton
  },

  data: () => ({
    title: "Cancelled Cheque",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    invalidFields: [],
    cancelledChequeDetails: {
      cancelled_cheque_uploaded: false
    }
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onInputEntered(key, value) {
      this.cancelledChequeDetails[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.cancelledChequeDetails[key],
        ALL_FIELDS_DATA,
        ALL_FIELDS_DATA
      );
    },

    getFieldLabel(key) {
      return ALL_FIELDS_DATA[key]["label"];
    },

    showFieldError(fieldKey) {
      return this.invalidFields && this.invalidFields.includes(fieldKey);
    },

    getFieldValue(key) {
      return this.cancelledChequeDetails ? this.cancelledChequeDetails[key] : "";
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    onCancelledChequeAttached(e) {
      const file = e.files[0];
      this.loading = true;
      DataSource.createDocument(
        EntityType.LOANS,
        LoanScopeDataHolder.getLoanId(),
        DocumentDescription.CANCELLED_CHEQUE.name,
        DocumentDescription.CANCELLED_CHEQUE.description,
        DocumentDescription.CANCELLED_CHEQUE.directory,
        file
      )
        .then(createDocumentRes => {
          this.loading = false;
          if (createDocumentRes.errorOccurred) {
            this.showError(createDocumentRes.data);
          } else {
            this.onInputEntered("cancelled_cheque_uploaded", true);
            this.showToast(DOCUMENT_UPLOADED);
          }
        })
    },

    onSubmit() {
      if (this.checkForValidation()) {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.cancelledChequeDetails,
        ALL_FIELDS_DATA,
        ALL_FIELDS_DATA
      );

      return !this.invalidFields || this.invalidFields.length === 0;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    }
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CANCELLED_CHEQUE];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    documentAttachImage() {
      return this.cancelledChequeDetails.cancelled_cheque_uploaded
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    attachFileButtonTextStyle() {
      return { color: "#ffffff" };
    },

    attachFileButtonStyle() {
      return {
        "background-color": "#f87246",
        "border-width": "1px",
        "border-style": "solid",
        "border-color": "gray"
      };
    },

    cancelledChequeInstruction(){
      return LoanScopeDataHolder.isOnboardingLoan() ? 
      "Please upload Cancelled Cheque as a proof of bank details submitted to receive money disbursements." : " ";
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

